import React, { useEffect, useMemo, useState } from "react";
import StatusBadge from "./StatusBadge";
import ErrorDetailsModal from "./ErrorDetailsModal";
import { FiArrowRight, FiEye, FiFileText } from "react-icons/fi";
import { AIStarIcon, FlightNewIcon, NewExcursionIcon, NewHotelIcon } from "../../../helper/HwIcon";
import api from "../../../helper/errorMonitorApi";

const PAGE_SIZE = 10;

export const getVendorIcon = (vendor) => {
  const v = (vendor || "").toLowerCase();
  if (v.includes("flight")) return <FlightNewIcon />;
  if (v.includes("hotel")) return <NewHotelIcon />;
  return <NewExcursionIcon />;
};

const ErrorTable = ({ data ,resolving = false, onResolved = () => {}}) => {
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState({ key: "createdAt", direction: "desc" });
  const [error,setError]=useState("")
  const [modal, setModal] = useState({
    open: false,
    item: null,
    mode: "details",
    solution: null,
    solutionLoading: false,
  });

  const resolve = async (id) => {
    let res = await onResolved(id)
    if(res){
      setModal({ open: false, item: null, mode: "details" })
    } else {
      setError("Error in Resolving")
    }
  }
  const sorted = data

  // const sorted = useMemo(() => {
  //   if (!sort.key) return data || [];
  //   const arr = [...(data || [])];
  //   arr.sort((a, b) => {
  //     const av = a[sort.key];
  //     const bv = b[sort.key];
  //     if (av === bv) return 0;
  //     if (av == null) return 1;
  //     if (bv == null) return -1;
  //     if (av > bv) return sort.direction === "asc" ? 1 : -1;
  //     return sort.direction === "asc" ? -1 : 1;
  //   });
  //   return arr;
  // }, [data, sort]);

  useEffect(()=>{
    setPage(1)
  },[data])

  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const sliceStart = (currentPage - 1) * PAGE_SIZE;
  const pageData = sorted.slice(sliceStart, sliceStart + PAGE_SIZE);

  const toggleSort = (key) => {
    setSort((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };

  const handleGenerate = async (item,force=false) => {
    setModal({
      open: true,
      item,
      mode: "solution",
      solution: null,
      solutionLoading: true,
    });
    try {
      const res = await api.post("/generate-answer", { logId: item.id , force  });
      if (res.data?.statusCode !== 200 || !res.data?.data) {
        throw new Error("Bad response");
      }
      const data = res.data.data;
      setModal((prev) => ({
        ...prev,
        solution: {
          answer: data?.answer || "",
          codeSnippet: data?.codeSnippet || "",
          errorContext: data?.errorContext || null,
        },
        solutionLoading: false,
      }));
    } catch (e) {
      setModal((prev) => ({
        ...prev,
        solution: {
          answer: "Unable to generate solution at the moment. Please try again later.",
          codeSnippet: "",
        },
        solutionLoading: false,
      }));
    }
  };

  return (
    <>
      <div className="em-tableWrap">
        <div className="em-scrollHint">
          <span>Scroll horizontally to view more</span>
          <FiArrowRight />
        </div>
        <div className="em-tableScroll">
          <table className="em-table">
            <thead>
              <tr>
                <th >Module</th>
                <th >Vendor</th>
                <th>API Endpoint</th>
                <th>Error Message</th>
                <th >Severity</th>
                <th>User ID</th>
                <th >Created Time</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {pageData.length ? (
                pageData.map((item) => (
                  <tr key={item.id}>
                    <td>
                    <span className="em-vendor">
                        {getVendorIcon(item.module)} {item.module}
                      </span>
                    </td>
                    <td className="hw-text--capitalize">{item.vendor}</td>
                    <td>
                      <code>{String(item.route).length > 25 ? `${String(item.route).slice(0, 25)}...` : item.route}</code>
                    </td>
                    <td title={item.errorMessage} style={{ maxWidth: 420 }}>
                      {String(item.lastErrorMessage || "").length > 70
                        ? `${String(item.lastErrorMessage).slice(0, 70)}...`
                        : item.lastErrorMessage}
                    </td>
                    <td>
                      <StatusBadge value={item.resolved ? "Resolved" : item.severity} type="severity" />
                    </td>
                    <td>
                      <StatusBadge value={item.userId} type="status" />
                    </td>
                    <td>{new Date(item.createdAt).toLocaleString()}</td>
                    <td>
                      <div className="em-actions justify-end d-flex hw-gapy10">
                        {
                          !item?.resolved && <button
                          type="button"
                          className="em-btn"
                          onClick={() =>
                            setModal({
                              open: true,
                              item,
                              mode: "details",
                              solution: null,
                              solutionLoading: false,
                            })
                          }
                        >
                          <FiEye /> 
                        </button>
                        }
                        <button
                          type="button"
                          className="em-btn em-btn--primary"
                          onClick={() => handleGenerate(item)}
                        >
                          {item?.resolved ? "View Solution" : <>{<AIStarIcon/>} Generate</>}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    No errors found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="em-footer">
        <div className="em-muted">
          Showing {pageData.length} of {sorted.length} errors
        </div>
        <div className="d-flex hw-gapy16 align-items-center">
          <button
            type="button"
            className="em-btn"
            disabled={currentPage === 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
          >
            Prev
          </button>
          <span className="em-muted">
            {currentPage} / {totalPages}
          </span>
          <button
            type="button"
            className="em-btn"
            disabled={currentPage === totalPages}
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          >
            Next
          </button>
        </div>
      </div>

      <ErrorDetailsModal
        open={modal.open}
        item={modal.item}
        mode={modal.mode}
        solution={modal.solution}
        solutionLoading={modal.solutionLoading}
        onClose={() => setModal({ open: false, item: null, mode: "details" })}
        resolving={resolving}
        onResolved={resolve}
        error={error}
        handleGenerate={handleGenerate}
      />
    </>
  );
};

export default ErrorTable;

